import type { FunctionComponent } from 'react';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { ResultOf } from 'gql.tada';
import type { WebLink as WebLinkType } from '../../../app-kit/components/WebLink/types';
import { suburbPageQuery } from '../../graphql/suburbPageQuery';
import { mapApiBadgeVariantToBadgeVariant } from '../../../app-kit/helpers/mapApiBadgeVariantToBadgeVariant';
import { SuburbPagePropertyCollectionBrick } from './SuburbPagePropertyCollectionBrick';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';

type ApiSuburbPageWebLink = NonNullable<
  NonNullable<
    NonNullable<ResultOf<typeof suburbPageQuery>['suburbPageBySlug']>['propertyCollections'][number]
  >['searchPageWebLink']
>;

const mapApiSuburbPageWebLinkToWebLink = (
  apiSearchPageWebLink: ApiSuburbPageWebLink,
): WebLinkType => {
  return {
    ...apiSearchPageWebLink,
    variant: mapApiWeblinkVariantToLinkVariant(apiSearchPageWebLink.variant),
  };
};

export const SuburbPagePropertyCollectionBricksWithData: FunctionComponent = () => {
  const suburbPage = useSuburbPageQuery()?.data?.suburbPageBySlug;

  const collections = suburbPage?.propertyCollections ?? [];

  if (!collections.length) return null;
  const propertyCollections = collections.filter((collection) => collection !== null);

  return (
    <>
      {propertyCollections.map(
        ({ title, subtitle, properties, tracking, searchPageWebLink, collectionType }) => {
          if (!properties) return null;
          return (
            <SuburbPagePropertyCollectionBrick
              title={title}
              subtitle={subtitle}
              key={title}
              showPropTrackLogo={collectionType === 'SOLD'}
              properties={properties.map(
                ({ path, clickThroughTracking, priceV2, address, image, badge, features }) => ({
                  path,
                  clickThroughSource: clickThroughTracking,
                  title: priceV2,
                  subtitle: address,
                  image,
                  badge: {
                    ...badge,
                    variant: mapApiBadgeVariantToBadgeVariant(badge.variant),
                  },
                  features: features?.map((feature) => ({
                    ...feature,
                    iconName: feature.iconNameV2,
                  })),
                }),
              )}
              tracking={tracking}
              searchPageWebLink={
                searchPageWebLink ? mapApiSuburbPageWebLinkToWebLink(searchPageWebLink) : undefined
              }
            />
          );
        },
      )}
    </>
  );
};
